import type { MessagingChannelKind } from '@upme/contracts';

const CHANNEL_LABEL_RU: Record<MessagingChannelKind, string> = {
  TELEGRAM_MTPROTO: 'Telegram',
  INSTAGRAM_META: 'Instagram Direct',
  WHATSAPP_CLOUD: 'WhatsApp',
  FACEBOOK_MESSENGER: 'Facebook Messenger',
  VK_MESSAGES: 'VK',
  WEB_CHAT: 'Веб-чат',
};

/** Каналы с реализованным адаптером (обновлять по мере подключения). */
const IMPLEMENTED_CHANNELS = new Set<MessagingChannelKind>(['TELEGRAM_MTPROTO', 'INSTAGRAM_META']);

export function messagingChannelLabelRu(channel: MessagingChannelKind): string {
  return CHANNEL_LABEL_RU[channel];
}

export function isMessagingChannelImplemented(channel: MessagingChannelKind): boolean {
  return IMPLEMENTED_CHANNELS.has(channel);
}

export function listMessagingChannelsForAdmin(): Array<{
  kind: MessagingChannelKind;
  labelRu: string;
  implemented: boolean;
  connected: boolean;
}> {
  return (Object.keys(CHANNEL_LABEL_RU) as MessagingChannelKind[]).map((kind) => ({
    kind,
    labelRu: CHANNEL_LABEL_RU[kind],
    implemented: IMPLEMENTED_CHANNELS.has(kind),
    connected: false,
  }));
}

/** Подпись в фильтре каналов inbox (реализован vs подключён vs скоро). */
export function messagingChannelSelectSuffix(channel: {
  kind: MessagingChannelKind;
  implemented: boolean;
  connected: boolean;
}): string {
  if (!channel.implemented) return ' (скоро)';
  if (!channel.connected) return ' (не подключён)';
  return '';
}

export function resolveConversationContactLabel(input: {
  partyDisplayName: string | null | undefined;
  previewText: string | null | undefined;
}): string {
  const name = input.partyDisplayName?.trim();
  if (name) return name.slice(0, 200);
  const preview = input.previewText?.trim();
  if (preview) return preview.slice(0, 120);
  return 'Без имени';
}
